import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
})
export class DashboardCardComponent {
  @Input() public displayTitle: string;
  @Input() public logoPath: string;
  @Input() public redirectText: string;
  @Input() public withRedirect: boolean;
  @Input() public href = '';
  @Output() public cardClick = new EventEmitter<void>();

  public linkClicked(): void {
    this.cardClick.emit();
  }
}
